import { Fragment } from "react";
import { Link } from "react-router-dom";

function ArticlePreview({
  article_id,
  creative_url,
  title,
  basePath = "/blog",
}) {
  return (
    <Fragment>
      <Link to={`${basePath}/article/${article_id}`} className="article-link">
        <article className="article-preview">
          <img src={creative_url} alt={title} />
          <div className="preview-title-container">
            <h5>{title}</h5>
          </div>
        </article>
      </Link>
    </Fragment>
  );
}

export default ArticlePreview;
